import script from "./RemoveNoteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveNoteModal.vue?vue&type=script&setup=true&lang=js"

import "./RemoveNoteModal.vue?vue&type=style&index=0&id=5823f522&lang=scss&scoped=true"

import exportComponent from "D:\\Front-End\\note-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5823f522"]])

export default __exports__